<template>
  <div>

    <div class="css-grid pay-invoice-form__row">
      <div class="h-collapsible"></div>
      <div class="grid__col--12">
        <div class="grid pay-invoice__total-preview">
          <div class="grid__col--7 pay-invoice__total-title">
            <h1 class="pay-invoice__total--amount-title">Payment Amount:</h1>
          </div>
          <div class="grid__col--5 pay-invoice__total">
            <h3 class="pay-invoice__total--dollar-sign">$</h3>
            <h1 class="pay-invoice__total--amount">{{ amountSanitizedReformatted }}</h1>
          </div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>

    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--6">
          <label class="form__label">Card Number:</label>
          <div id="cardNumberContainer"></div>
        </div>
        <div class="grid__col--4">
          <label class="form__label">Expiration Date:</label>
          <div id="expirationDateContainer"></div>
        </div>
        <div class="grid__col--2">
          <label class="form__label">Sec Code:</label>
          <div id="securityCodeContainer"></div>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    
  </div>
</template>

<script>
  import StoreConnectedSelect from '../../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../../form-items/StoreConnectedInput.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditCardForm',
    components: {
      StoreConnectedInput,
      StoreConnectedSelect,
    },
    data() {
      return {
        store: 'payInvoice',
        action: 'setObjectProperty',
      };
    },
    computed: {
      ...mapGetters('payInvoice', ['amountSanitizedReformatted']),
      //...mapGetters('payInvoice', ['gravityAssetsUrl']),
    },
  };
</script>
